// extracted by mini-css-extract-plugin
export default {"root":"ks_hC7imLHq0XtVrWWhC","wrap":"CIWyaY3_TxgXk21Z2tqW","main":"M9Dj6AnYXevLhbs1A8BN","content":"mJQ35YzBZV_IZmZdw2c5","span":"z2lCq7gyJNsS9076uZ14","img":"WpFkqmIniSG8aNbh9h63"};